module.exports = __webpack_public_path__ + "static/media/HardmodeNeon_main.145ed6e2.jpg";